import {Injectable} from '@angular/core';

import {AuthenticationService} from './index';
import {LoginHelper} from '../helpers';
import {Subject} from "rxjs";
import {FixDates} from "../_decorators/date.decorator";
import {Load} from "../_decorators/loading.decorator";
import {HttpClient} from "@angular/common/http";
import {IndexConfigService} from "./index.config.service";

@Injectable()
export class LogService {
  public accountUpdated: Subject<any> = new Subject<any>();

  constructor(public http: HttpClient,
              public authenticationService: AuthenticationService,
              public config: IndexConfigService) {
  }

  @FixDates()
  @Load()
  getAll(filter: any) {

    const tenantName = LoginHelper.getTenantName();
    if (tenantName == null || LoginHelper.getUserToken() == null) {
      this.authenticationService.logout();

      return null;
    }

    return this.http.post<any>(this.config.api + '/api/logs/all', filter);
  }

  logNavigate(url) {
    return this.http.get<any>(this.config.api + '/api/log/navigate?url=' + encodeURIComponent(url));
  }
}
